import React from "react";
import { RIM_WIDTH, WHITE_RIM_WIDTH } from "./wheelMath";
import { useRaffleWheel } from "./RaffleWheelContext";

export const WheelRims = () => {
  const { center } = useRaffleWheel();

  return (
    <>
      <circle
        cx={center}
        cy={center}
        r={center - RIM_WIDTH / 2}
        fill="none"
        stroke="var(--palette-red-500)"
        strokeWidth={RIM_WIDTH}
      />
      <circle
        cx={center}
        cy={center}
        r={center - RIM_WIDTH - WHITE_RIM_WIDTH / 2}
        fill="none"
        stroke="var(--palette-white)"
        strokeWidth={WHITE_RIM_WIDTH}
      />
    </>
  );
};
